import {FormikTextInput} from '@shipwell/shipwell-ui';
import {Field} from 'formik';
export const LineItemWeightField = ({index}: {index: number}) => (
  <Field label="Weight" name={`line_items[${index}].package_weight`} component={FormikTextInput} />
);
